import { ConfigState } from "../../models/ConfigState";

const getUserConfigFetch = (state: ConfigState) => {
    state.isLoading = true;
}

export default getUserConfigFetch;